import { PropsWithChildren, useEffect, useRef } from 'react'

import { useSize } from 'ahooks'
import { Affix } from 'antd'

import { BasicProps } from '@eastcoal/common/types/component'
import { getFirstScrolledParent } from '@eastcoal/common/utils/dom'
import { pick } from '@eastcoal/common/utils/object'

import { useToolbarStore } from '../Store/hooks/useStore'

export const ToolbarActionBar = ({
  className,
  style,
  children
}: PropsWithChildren<BasicProps>) => {
  const { setTotalWidth } = useToolbarStore(state =>
    pick(state, ['setTotalWidth'])
  )
  const ref = useRef<HTMLDivElement>(null)
  const size = useSize(ref)

  useEffect(() => {
    const width = size?.width
    const el = ref.current
    if (!(el && width)) {
      return
    }
    const computedStyle = window.getComputedStyle(el)
    const paddingInlineStart = parseFloat(computedStyle.paddingInlineStart)
    const paddingInlineEnd = parseFloat(computedStyle.paddingInlineEnd)
    const totalWidth = width - paddingInlineStart - paddingInlineEnd
    setTotalWidth(totalWidth)
  }, [setTotalWidth, size?.width])

  return (
    <Affix
      offsetTop={0}
      target={() => {
        return ref.current ? getFirstScrolledParent(ref.current) : window
      }}
    >
      <div ref={ref} className={className} style={style}>
        {children}
      </div>
    </Affix>
  )
}
